export var TelemetryExportApplyStatus;
(function (TelemetryExportApplyStatus) {
    TelemetryExportApplyStatus["TELEMETRY_EXPORT_APPLY_STATUS_PENDING"] = "PENDING";
    TelemetryExportApplyStatus["TELEMETRY_EXPORT_APPLY_STATUS_APPLIED"] = "APPLIED";
    TelemetryExportApplyStatus["TELEMETRY_EXPORT_APPLY_STATUS_FAILED"] = "FAILED";
})(TelemetryExportApplyStatus || (TelemetryExportApplyStatus = {}));
